import * as React from 'react';
import * as styles from './style.css';
import { UIText1 } from '@cian/ui-kit';
import { IAwardsSource } from '../../types/developerV2/awards';

interface ISourcesProps {
  source: IAwardsSource;
}

export const RatingsSources = ({ source }: ISourcesProps) => {
  return (
    <UIText1>
      Все рейтинги можно посмотреть на&nbsp;
      <a href={source.url} target="_blank" rel="noreferrer" className={styles['source-link']}>
        сайте
      </a>
    </UIText1>
  );
};
